// extracted by mini-css-extract-plugin
export var authorDetailsWrapperStyle = "quote_large_center_aligned-module--authorDetailsWrapperStyle--km8Lj";
export var authorNameStyle = "quote_large_center_aligned-module--authorNameStyle--1JD6d";
export var clientLogoStyle = "quote_large_center_aligned-module--clientLogoStyle--f0sxr";
export var quoteAttributionStyle = "quote_large_center_aligned-module--quoteAttributionStyle--ZbJ0q";
export var quoteBodyStyle = "quote_large_center_aligned-module--quoteBodyStyle--y2NqJ";
export var textColorDarkStyle = "quote_large_center_aligned-module--textColorDarkStyle--PKj7n";
export var textColorLightStyle = "quote_large_center_aligned-module--textColorLightStyle--reSkG";